// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute = ({ user, role, children }) => {
//   if (!user) {
//     console.error('ProtectedRoute: No user found, redirecting to login');
//     return <Navigate to="/login" />;
//   }
  
//   if (user.role !== role) {
//     console.error('ProtectedRoute: Role mismatch, redirecting to login');
//     return <Navigate to="/login" />;
//   }
  
//   return children;
// };


// export default ProtectedRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ user, role, loading, children }) => {
  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "2em" }}>Loading...</div>;
  }
  if (!user) {
    console.error('ProtectedRoute: No user found, redirecting to login');
    return <Navigate to="/login" />;
  }
  if (user.role !== role) {
    console.error('ProtectedRoute: Role mismatch, redirecting to login');
    return <Navigate to="/login" />;
  }
  return children;
};

export default ProtectedRoute;
